/* maxmaxhunt:start hunt.js */
(() => {

  const modal = document.getElementById('hunt-modal');
  if (!modal) return;

  const panel      = modal.querySelector('.hunt-modal__panel');
  const textEl     = modal.querySelector('.hunt-modal__text');
  const codeEl     = document.getElementById('hunt-code');
  const applyA     = document.getElementById('hunt-apply');
  const appliedEl  = document.getElementById('hunt-applied');
  const applyErrEl = document.getElementById('hunt-apply-error');
  const closeBtn   = modal.querySelector('[data-close-btn]');


  const normCode = v => String(v || '').trim();


  const extractPercent = code => {
    const m = String(code).match(/(\d{1,2})$/);
    return m ? parseInt(m[1],10) : null;
  };


  const buildMessage = codeRaw => {

    const code = normCode(codeRaw).toUpperCase();


    if(code === 'OHMYGIFT'){
      return{
        html:
        `Here’s your promo code for a free eyeliner 
        <a href="https://lamel.ua/products/oh-my-color-gel-eye-liner" target="_blank">
        Oh My Color Gel Eye Liner</a>.<br>
        Valid on the entire store and can be combined with current promotions.`,
        code
      };
    }


    if(code === 'LIPGIFT'){
      return{
        html:
        `Here’s your promo code for a free lip pencil 
        <a href="https://lamel.ua/products/wooden-lip-pencil" target="_blank">
        Lip pencil</a>.<br>
        Valid on the entire store and can be combined with current promotions.`,
        code
      };
    }


    const pct = extractPercent(code) ?? 5;


    return{
      html:
      `Here’s your promo code for 
      <span class="hunt-discount">${pct}%</span> off.<br>
      Valid on the entire store and can be combined with current promotions.`,
      code
    };

  };


  const setHidden = (el,val)=>{ if(el) el.hidden = val };


  const openModal = ({code,applied=false}) => {

    const msg = buildMessage(code);

    textEl.innerHTML = msg.html;
    codeEl.textContent = msg.code;

    setHidden(applyErrEl,true);

    if(applied){

      setHidden(appliedEl,false);

      applyA.textContent = 'Continue shopping';
      applyA.dataset.state='continue';

    }else{

      setHidden(appliedEl,true);

      applyA.textContent = 'Apply promo code';
      applyA.dataset.state='apply';

    }


    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('hunt-lock');

    (closeBtn||panel)?.focus();

  };


  const closeModal = ()=>{

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('hunt-lock');

  };


  document.addEventListener('click',e=>{

    const trigger = e.target.closest('.hunt-trigger');

    if(trigger){

      openModal({code:trigger.dataset.code});
      return;

    }

    if(e.target.matches('[data-close]') || e.target.closest('[data-close]')){

      closeModal();

    }

  });


  document.addEventListener('keydown',e=>{
    if(e.key==='Escape' && modal.classList.contains('is-open')) closeModal();
  });


  applyA.addEventListener('click',e=>{

    e.preventDefault();

    if(applyA.dataset.state==='continue'){
      closeModal();
      return;
    }


    const code = normCode(codeEl.textContent);

    sessionStorage.setItem('hunt_applied_code',code);


    const redirect =
      `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(location.pathname+location.search)}`;

    location.href = redirect;

  });


  const appliedCode = sessionStorage.getItem('hunt_applied_code');

  if(appliedCode){

    sessionStorage.removeItem('hunt_applied_code');

    openModal({
      code:appliedCode,
      applied:true
    });

  }


})();
 /* maxmaxhunt:end hunt.js */